/**
 * browser.ts — IIFE entry point.
 *
 * Installs the SDK onto `window.gokwik` idempotently: a second `<script>` load
 * of this bundle (e.g. two teams both including the tag on one page) REUSES the
 * first-loaded instance instead of clobbering it and its initialized config.
 * All real logic lives in ./index; this file is the thin, side-effecting glue
 * that binds the API to the global (excluded from coverage in jest.config.js).
 *
 * NOTE: no exports — that keeps the rollup IIFE nameless (pure side effect), so
 * nothing is force-assigned to the global except via the guarded installGlobal.
 */
import { buildGlobalApi, installGlobal } from './index';

if (typeof window !== 'undefined') {
  installGlobal(
    window as unknown as { gokwik?: { version?: unknown; init?: unknown; hit?: unknown } },
    buildGlobalApi(),
  );
}
